// export const apiEndPoints = 'http://admin.puretouch.localhost'; // <== Local
// export const apiEndPoints = 'https://puretouchadmin.lts247.xyz'; // <== Beta
// const apiEndPoints = 'https://puretouch-api.lts247.xyz'; // <== Live
const apiEndPoints =
    process.env.REACT_APP_ENV === "production"
        ? ""
        : process.env.REACT_APP_BASE_URL;

export const appconfig = {
    appName: "PureTouch",
    appVersion: 1,
    baseURL: apiEndPoints,
    company_pid: "puretouc"
}


export const urls = {
    deviceRegister: "/auth/get-device-id",
    loginByPassword: "/auth/do-login",
    logout: "/auth/logout",
    userEmailVerify: "/auth/forget-password",
    setPassword: "/auth/reset-password",
    getRefreshToken: "/auth/refresh-token",
    uploadMedia: "/system/upload-media-base64",
    getProfileDetails: "/admin/get-details",
    updateUserProfile: "/admin/update-profile",
    getCms: "/cms/get",
    chatList: "/chat/get-chat-management-list",
    employeeList: "/admin/get-user-list",
    createChatRoom: "/chat/open-employee-chat",
    sendMessage: "/chat/create-chat-message",
    getChatMessages: "/chat/get-chat-room-message",
    getActivityList: "/activity/get-daily-activity-list",
    createManualLog: "/activity/create-manual-time",
    getPendingJobDetails: "/job/get-pending-job-details",
    jobList: "/job/get-my-jobs",
    jobDetail: "/job/get-mobile-job-detail",
    saveDamageNotes: "/job/save-damage-notes",
    uploadWorkPhoto: "/job/upload-work-photo",
    startJob: "/job/start-job",
    getCourseList: "/lms/get-course",
    getCourseChapters: "/lms/get-course-chapters",
    getModuleDetail: "/lms/get-module-detail",
    submitTest: "/lms/submit-test",
    markCompleted: "/lms/mark-completed",
    getServiceList: "/jcc/get-service-list",
    getServiceDetail: "/jcc/get-service-detail",
    submitServiceReport: "/jcc/save-assessment",
    sendAssessmentReport: "/job/send-assessment-report",
    getRewardsList: "/product/get-product-list",
    getRewardDetails: "/product/get-product-detail",
    getPointSummary: "/reward/get-employee-points-summary",
    redeemReward: "/reward/redeem-product",
    leaderBoard: "/reward/get-leader-board",
    pointHistory: "/reward/report/mobile-dashboard",
    salesStats: "/cms/get-sales-stats",
    heartBeat: "/user/heart-beat",
    toggleNotification: '/user/toggle-push-notification',
    deleteAccountVerifyOtp: "/auth/verify-otp",
    deleteAccount: "/auth/delete-account"
}